import React, { useEffect, useState } from "react";
import arrow from "../../../../Assets/Icons/nextIcon.png";
import dropdown from "../../../../Assets/Icons/dropdownBlack.svg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import TruncateWithExpand from "./TruncateWithExpand";
import envConfig from "../../../../config/config";
const Table = () => {
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filters, setFilters] = useState({
    ComponentName: "",
    Technology: "",
    Category: "",
  });
  const [openDropdown, setOpenDropdown] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const { instance } = useMsal();
  const navigate = useNavigate();
  const closeContributor = () => {
    navigate("/dashboard/ui_repo");
  };

  useEffect(() => {
    fetchTableData();
  }, []);

  const fetchTableData = async () => {
    try {
      const response = await fetch(
        envConfig.REACT_APP_UIREPO+"/api/request/"
      );
      const data = await response.json();
      setTableData(data);
    } catch (error) {
      console.error("Data is not fetched", error);
    }
  };

  const filteredData = tableData.filter((item) => {
    return (
      (filters.ComponentName === "" ||
        item.ComponentName === filters.ComponentName) &&
      (filters.Technology === "" || item.Technology === filters.Technology) &&
      (filters.Category === "" || item.Category === filters.Category)
    );
  });

  const totalPages = Math.ceil(filteredData.length / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const currentData = filteredData.slice(startIndex, startIndex + pageSize);

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
    setOpenDropdown(null);
    setCurrentPage(1);
  };

  const uniqueValues = (key) => {
    return [...new Set(tableData?.map((item) => item[key]).filter(Boolean))];
  };

  const handlePageSizeChange = (e) => {
    setPageSize(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleCheckboxChange = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleSubmit = async () => {
    const selectedRowsData = tableData.filter((item) =>
      selectedRows.includes(item._id)
    );
    if (selectedRowsData.length === 0) {
      toast.error("Please select at least one row to work on.", {
        position: "top-center",
        hideProgressBar: true,
        theme: "colored",
      });
      return;
    }

    const selectedIds = selectedRowsData?.map((row) => row._id);

    try {
      await Promise.all(
        selectedIds?.map((id) =>
          fetch(`https://dev.appstudioltts.com/api/request/${id}`, {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
          }).then((res) => res.json())
        )
      );

      await Promise.all(
        selectedRowsData?.map((row) => {
          const data = {
            ComponentName: row.ComponentName,
            ComponentDetails: row.ComponentDetails,
            Category: row.Category,
            Technology: row.Technology,
            SenderName: instance.getAllAccounts()?.[0]?.name,
            Email: instance.getAllAccounts()?.[0]?.username,
            ComponentState: "In Progress",
            ComponentType:row.ComponentType,
          };

          return fetch(
            "https://dev.appstudioltts.com/api/linkstateupdate/submitdata",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(data),
            }
          ).then((res) => res.json());
        })
      );

      toast.success("Component added to MyComponents successfully!", {
        position: "top-center",
        hideProgressBar: true,
        theme: "colored",
      });

      const userEmail = instance.getAllAccounts()?.[0]?.username;
      await fetch(
        "https://prod.appstudioltts.com/api/contribution-mail/send-email",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: userEmail }),
        }
      );

      setSelectedRows([]);
      fetchTableData();
    } catch (error) {
      console.error("Error processing selected rows:", error);
      toast.error("An error occurred. Please try again later.", {
        position: "top-center",
        theme: "colored",
      });
    }
  };

  return (
    <div className="h-[100%] pt-6 relative">
      <div className="overflow-x-hidden border border-gray-300 rounded-md">
        <div className="h-[45vh] overflow-y-auto">
          <table className="min-w-full bg-white">
            <thead className="bg-[#dff3f9] sticky text-bold text-sm top-0 z-10">
              <tr>
                <th className="text-left px-4 py-2 border-b">Select</th>
                <th className="text-left px-4 py-2 border-b">Sr No</th>

                {/* Component Name Filter */}
                <th className="text-left px-4 py-2 border-b relative">
                  <div className="flex items-center gap-2">
                    Component Name
                    <img
                      src={dropdown}
                      alt="Filter"
                      className="w-4 h-4 cursor-pointer"
                      onClick={() =>
                        setOpenDropdown(
                          openDropdown === "ComponentName"
                            ? null
                            : "ComponentName"
                        )
                      }
                    />
                  </div>
                  {openDropdown === "ComponentName" && (
                    <div className="absolute left-0 mt-1 w-40 bg-white border shadow z-20 rounded max-h-40 overflow-y-auto">
                      <button
                        onClick={() => handleFilterChange("ComponentName", "")}
                        className="block w-full px-3 py-1 text-left hover:bg-gray-100 font-normal"
                      >
                        All
                      </button>
                      {uniqueValues("ComponentName")?.map((value, i) => (
                        <button
                          key={i}
                          onClick={() =>
                            handleFilterChange("ComponentName", value)
                          }
                          className="block w-full px-3 py-1 text-left hover:bg-gray-100 font-normal"
                        >
                          {value}
                        </button>
                      ))}
                    </div>
                  )}
                </th>

                <th className="text-left text-bold px-4 py-2 border-b w-[350px]">
                  Component Details
                </th>
                <th className="text-left text-bold w-[200px] px-[15px] py-2 border-b">
                  Requested Component
                </th>
                {/* Technology Filter */}
                <th className="text-left text-bold px-4 py-2 border-b relative">
                  <div className="flex items-center gap-2">
                    Technology
                    <img
                      src={dropdown}
                      alt="Filter"
                      className="w-4 h-4 cursor-pointer"
                      onClick={() =>
                        setOpenDropdown(
                          openDropdown === "Technology" ? null : "Technology"
                        )
                      }
                    />
                  </div>
                  {openDropdown === "Technology" && (
                    <div className="absolute left-0 mt-1 w-40 bg-white border shadow z-20 rounded max-h-40 overflow-y-auto">
                      <button
                        onClick={() => handleFilterChange("Technology", "")}
                        className="block w-full px-3 py-1 text-left hover:bg-gray-100 font-normal"
                      >
                        All
                      </button>
                      {uniqueValues("Technology")?.map((value, i) => (
                        <button
                          key={i}
                          onClick={() =>
                            handleFilterChange("Technology", value)
                          }
                          className="block w-full px-3 py-1 text-left hover:bg-gray-100 font-normal"
                        >
                          {value}
                        </button>
                      ))}
                    </div>
                  )}
                </th>

                {/* Category Filter */}
                <th className="text-left px-4 py-2 border-b relative">
                  <div className="flex items-center gap-2">
                    Category
                    <img
                      src={dropdown}
                      alt="Filter"
                      className="w-4 h-4 cursor-pointer"
                      onClick={() =>
                        setOpenDropdown(
                          openDropdown === "Category" ? null : "Category"
                        )
                      }
                    />
                  </div>
                  {openDropdown === "Category" && (
                    <div className="absolute left-0 mt-1 w-36 bg-white border shadow z-20 rounded max-h-40 overflow-y-auto">
                      <button
                        onClick={() => handleFilterChange("Category", "")}
                        className="block w-full px-3 py-1 text-left hover:bg-gray-100 font-normal"
                      >
                        All
                      </button>
                      {uniqueValues("Category")?.map((value, i) => (
                        <button
                          key={i}
                          onClick={() => handleFilterChange("Category", value)}
                          className="block w-full px-3 py-1 text-left hover:bg-gray-100 font-normal"
                        >
                          {value}
                        </button>
                      ))}
                    </div>
                  )}
                </th>
              </tr>
            </thead>
            <tbody>
              {currentData?.length > 0 ? (
                currentData?.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-100">
                    <td className="text-left px-4 py-2 border-b">
                      <input
                        type="checkbox"
                        checked={selectedRows.includes(item._id)}
                        onChange={() => handleCheckboxChange(item._id)}
                      />
                    </td>
                    <td className="text-left px-4 py-2 border-b">
                      {(currentPage - 1) * pageSize + index + 1}
                    </td>
                    <td className="text-left px-4 py-2 border-b">
                      {item?.ComponentName}
                    </td>
                    <td className="px-4 py-2 border-b ">
                     <TruncateWithExpand text={item?.ComponentDetails}  />
                    </td>
                    <td className="px-[7px] py-2 border-b">
                      <span
                        className={`${
                          item?.ComponentType === "new" ? "bg-green-500 w-[80px] inline-flex rounded-2xl justify-center" : "bg-blue-400 w-[80px] inline-flex rounded-2xl justify-center"
                        } `}
                      >
                        {item?.ComponentType?.charAt(0).toUpperCase() + item.ComponentType?.slice(1)}
                      </span>{" "}
                      component
                    </td>

                    <td className="px-4 py-2 border-b">{item?.Technology}</td>
                    <td className="px-4 py-2 border-b">{item?.Category}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center px-4 py-4">
                    Loading or No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination and Rows per page */}
      <div className="flex justify-end items-center mt-2 gap-4">
        {/* Dynamic rows per page */}
        <div className="flex items-center text-sm">
          <span className="mr-2">Rows per page:</span>
          <select
            value={pageSize}
            onChange={handlePageSizeChange}
            className="border border-gray-300 rounded px-2 py-1 text-sm bg-white"
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </select>
        </div>

        <span className="text-sm font-medium mr-2">
          Page {currentPage} of {totalPages}
        </span>
        <img
          src={arrow}
          onClick={handlePrev}
          style={{ transform: "rotate(180deg)" }}
          className={`h-4 w-4 m-2 cursor-pointer ${
            currentPage === 1
              ? "opacity-30 cursor-not-allowed"
              : "hover:scale-110"
          }`}
          alt="Previous"
        />
        <img
          src={arrow}
          onClick={handleNext}
          className={`h-4 w-4 m-2 cursor-pointer ${
            currentPage === totalPages
              ? "opacity-30 cursor-not-allowed"
              : "hover:scale-110"
          }`}
          alt="Next"
        />
      </div>

      <div className="flex justify-end gap-[8px] mt-2">
        <button
          className="p-2 px-4 border border-[#1976d2] text-[12px] w-24 rounded-md"
          onClick={closeContributor}
        >
          Close
        </button>
        <button
          className="p-2 px-4 border border-[#1976d2] text-[12px] w-24 bg-[#1976d2] text-white"
          onClick={handleSubmit}
        >
          Work On!
        </button>
      </div>
    </div>
  );
};

export default Table;
